/**
 * Kratome — Quick View
 * Fetches product data via Shopify's /products/{handle}.js and builds a
 * compact buy view without leaving the page. Add-to-cart uses the same
 * /cart/add.js endpoint as the rest of the site, then triggers the cart
 * drawer (cart.js) via a custom event.
 */
(function () {
  "use strict";

  var modal = document.querySelector("[data-quick-view]");
  var body = modal ? modal.querySelector("[data-quick-view-body]") : null;
  var closeBtn = modal ? modal.querySelector("[data-quick-view-close]") : null;
  var backdrop = modal ? modal.querySelector(".quick-view__backdrop") : null;

  function open() {
    if (!modal) return;
    modal.dataset.open = "true";
    document.body.style.overflow = "hidden";
  }
  function close() {
    if (!modal) return;
    modal.dataset.open = "false";
    document.body.style.overflow = "";
  }

  function money(cents) {
    return (cents / 100).toLocaleString(document.documentElement.lang || "en", {
      style: "currency",
      currency: window.Shopify && window.Shopify.currency ? window.Shopify.currency.active : "EUR",
    });
  }

  function render(product) {
    var variant = product.variants[0];
    var html =
      '<div class="quick-view__media">' +
      (product.featured_image ? '<img src="' + product.featured_image + '" alt="' + product.title + '" loading="lazy">' : "") +
      "</div>" +
      '<div class="quick-view__info">' +
      '<h2 class="h3">' + product.title + "</h2>" +
      '<p class="quick-view__price">' + money(variant.price) + "</p>" +
      '<form data-quick-view-form>' +
      '<input type="hidden" name="id" value="' + variant.id + '">' +
      '<button type="submit" class="btn btn--primary btn--lg btn--full">' + (variant.available ? kvt("add_to_cart","Add to cart") : kvt("sold_out","Sold out")) + "</button>" +
      "</form>" +
      '<a href="' + product.url + '" class="btn--ghost" style="display:inline-block; margin-top:12px;">' + kvt("view_full_product","View full product page →") + '</a>' +
      "</div>";
    body.innerHTML = html;

    var form = body.querySelector("[data-quick-view-form]");
    if (form) {
      form.addEventListener("submit", function (e) {
        e.preventDefault();
        var btn = form.querySelector("button");
        var original = btn.textContent;
        btn.disabled = true;
        btn.textContent = kvt("adding","Adding…");
        fetch("/cart/add.js", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ id: variant.id, quantity: 1 }),
        })
          .then(function () {
            close();
            document.dispatchEvent(new CustomEvent("kratome:cart-updated"));
          })
          .finally(function () {
            btn.disabled = false;
            btn.textContent = original;
          });
      });
    }
  }

  function loadProduct(handle) {
    if (!body) return;
    body.innerHTML = '<div class="quick-view__loading">' + kvt("loading","Loading…") + '</div>';
    open();
    fetch("/products/" + handle + ".js")
      .then(function (r) { return r.json(); })
      .then(render)
      .catch(function () {
        body.innerHTML = '<p class="quick-view__loading">' + kvt("could_not_load","Could not load this product.") + '</p>';
      });
  }

  function init() {
    document.addEventListener("click", function (e) {
      var trigger = e.target.closest("[data-quick-view-trigger]");
      if (!trigger) return;
      e.preventDefault();
      e.stopPropagation();
      loadProduct(trigger.dataset.productHandle);
    });
    if (closeBtn) closeBtn.addEventListener("click", close);
    if (backdrop) backdrop.addEventListener("click", close);
    document.addEventListener("keydown", function (e) { if (e.key === "Escape") close(); });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
